module.exports = __webpack_public_path__ + "img/밀키트.f6a2c5ac.png";